module.exports = __webpack_public_path__ + "static/media/icon-arabic.cb9b5b8a.svg";